import React, { useState } from 'react';

import RefreshIcon from '@mui/icons-material/Refresh';
import { Box, InputAdornment, TextField, useTheme } from '@mui/material';

import { useIntelState } from '../../context/IntelState';
import { ReactComponent as ArrowLeftSVG } from '../../svgs/design/nav-arrow-single-left.svg';
import { ReactComponent as ArrowRightSVG } from '../../svgs/design/nav-arrow-single-right.svg';

const EnemySwitcher = () => {
  const { intelState, intelDispatch } = useIntelState();
  const [kd, setKd] = useState<string>(intelState.enemyKd);
  const [islandDown, setIslandDown] = useState<boolean>(false);
  const [islandUp, setIslandUp] = useState<boolean>(false);
  const [kingdomDown, setKingdomDown] = useState<boolean>(false);
  const [kingdomUp, setKingdomUp] = useState<boolean>(false);
  const theme = useTheme();

  const setKdChange = (context: string) => {
    const arr = kd.split(':');
    let newKd = '';
    if (context === 'islandDown') {
      newKd = `${Math.max(Number(arr[0]) - 1, 1)}:${arr[1]}`;
    }
    if (context === 'islandUp') {
      newKd = `${Number(arr[0]) + 1}:${arr[1]}`;
    }
    if (context === 'kingdomDown') {
      newKd = `${arr[0]}:${Math.max(Number(arr[1]) - 1, 1)}`;
    }
    if (context === 'kingdomUp') {
      newKd = `${arr[0]}:${Number(arr[1]) + 1}`;
    }
    setKd(newKd);
    intelDispatch({ type: 'SET_ENEMY', payload: newKd });
    intelDispatch({ type: 'SET_ENEMY_PLAN', payload: undefined });
  };

  const selectEnemy = () => {
    intelDispatch({ type: 'SET_ENEMY', payload: kd });
    intelDispatch({ type: 'SET_ENEMY_PLAN', payload: undefined });
  };

  const validateKeyPress = (e: any): void => {
    const regex = /[0-9:]/gm;
    if (e.key === 'Enter') {
      selectEnemy();
      e.preventDefault();
    } else if (!regex.exec(e.key)) {
      e.preventDefault();
    }
  };

  const defaultFill = theme.palette.mode === 'dark' ? '#fff' : '#000';
  const svgStyle = {
    height: '16px',
    width: '16px',
    marginRight: '1px',
    cursor: islandDown ? 'pointer' : 'default',
  };
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center'
      }}>
      <ArrowLeftSVG
        style={{
          ...svgStyle,
          fill: islandDown ? theme.palette.primary.main : defaultFill,
          cursor: islandDown ? 'pointer' : 'default',
        }}
        onMouseEnter={() => setIslandDown(true)}
        onMouseLeave={() => setIslandDown(false)}
        onClick={() => setKdChange('islandDown')}
      />
      <ArrowLeftSVG
        style={{
          ...svgStyle,
          fill: kingdomDown ? theme.palette.primary.main : defaultFill,
          cursor: kingdomDown ? 'pointer' : 'default',
        }}
        onMouseEnter={() => setKingdomDown(true)}
        onMouseLeave={() => setKingdomDown(false)}
        onClick={() => setKdChange('kingdomDown')}
      />
      <TextField
        id='enemy-switcher'
        label='Enemy'
        value={kd}
        variant='outlined'
        size='small'
        sx={{
          width: '90px',
          marginX: '3px',
          div: { paddingRight: '2px', fontSize: '16px' },
        }}
        onChange={(event) => setKd(event.target.value)}
        onKeyPress={validateKeyPress}
        InputProps={{
          endAdornment: (
            <InputAdornment position='end' className='adornment'>
              <RefreshIcon
                sx={{
                  '&:hover': { cursor: 'pointer', color: 'primary.main' },
                }}
                fontSize='small'
                onClick={() => selectEnemy()}
              />
            </InputAdornment>
          ),
        }}
      />
      <ArrowRightSVG
        style={{
          ...svgStyle,
          fill: kingdomUp ? theme.palette.primary.main : defaultFill,
          cursor: kingdomUp ? 'pointer' : 'default',
        }}
        onMouseEnter={() => setKingdomUp(true)}
        onMouseLeave={() => setKingdomUp(false)}
        onClick={() => setKdChange('kingdomUp')}
      />
      <ArrowRightSVG
        style={{
          ...svgStyle,
          fill: islandUp ? theme.palette.primary.main : defaultFill,
          cursor: islandUp ? 'pointer' : 'default',
        }}
        onMouseEnter={() => setIslandUp(true)}
        onMouseLeave={() => setIslandUp(false)}
        onClick={() => setKdChange('islandUp')}
      />
    </Box>
  );
};

export default EnemySwitcher;
